import { ConfirmationModal } from '@/components/modals/ConfirmationModal'

interface Props {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  loading: boolean
  /** The web runs in the OrbitalX room: there is no BigMarker push, and the recording, waiting video or image, and polls unlock (ORB-1086). */
  isRoom?: boolean
}

export function WebReopenModal({ isOpen, onClose, onConfirm, loading, isRoom }: Props) {
  return (
    <ConfirmationModal
      isOpen={isOpen}
      title="Reopen Web"
      message={isRoom
        ? 'Reopening will allow editing of online event details, speakers, and schedule, and unlocks the recording, waiting video or image, and polls. Sign off again once the changes are made.'
        : "Reopening will allow editing of online event details, speakers, and schedule. Changes aren't pushed to BigMarker until you sign off again."}
      type="warning"
      confirmText="Reopen"
      onConfirm={onConfirm}
      onCancel={onClose}
      loading={loading}
    />
  )
}
